var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.506 30.702h1.648V15.051h-1.648v15.651zM20.331.224C9.408.224.551 9.076.551 19.994s8.857 19.768 19.78 19.768c10.922 0 19.776-8.85 19.776-19.768 0-10.918-8.854-19.77-19.776-19.77zm0 37.891c-9.998 0-18.131-8.129-18.131-18.121 0-9.993 8.133-18.122 18.131-18.122 9.997 0 18.129 8.129 18.129 18.122 0 9.992-8.132 18.121-18.129 18.121zm0-29.654c-.708 0-1.649.996-1.649 1.649 0 .652.941 1.646 1.649 1.646.703 0 1.647-.944 1.647-1.646 0-.704-.944-1.649-1.647-1.649z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInformation);
export default __webpack_public_path__ + "static/media/ico-information.0bb75f9e3d3f18f0e97613a2dd6fd240.svg";
export { ForwardRef as ReactComponent };